
import { createSlice } from "@reduxjs/toolkit";
import { apiCallBegan } from "../api";
import  BASE_URL  from "../../config/host";

export const productcategorySlice = createSlice({
    name: 'productcategories',
    loading: false,
    initialState: {
        productcategorylist: [],
        productcategoryCount: 0
    },
    reducers:{
        listRequested: (state, action)=>{
            state.loading = true;
        },
        listRequestFailed: (state, action)=>{
            state.loading = false;
            state.productcategorylist ='';
            //console.log(action.payload);
        },
        listReceived: (state, action)=>{
            state.loading = false;
            state.productcategorylist = action.payload.data?action.payload.data:[];
            state.productcategoryCount = action.payload.count || 0
        }
    }
});


export const {listReceived,listRequested ,listRequestFailed } = productcategorySlice.actions;
//console.log(body);
export const fetchProductcategories = (body)=> apiCallBegan({
    url: '/product_categories/list',
    method: 'post',
    data: body,
    baseUrl: BASE_URL,
    onSuccess: listReceived.type,
    onStart: listRequested.type,
    onError: listRequestFailed.type
 
});














